import React from 'react';

const CommonPageComponent = ({ parentClassName, containerClassName, children }) => {
  if (parentClassName) {
    return (
      <div className={`${parentClassName}`}>
        <div className="main">
          <div className="section">
            <div className={`container ${containerClassName}`}>{children}</div>
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="main">
      <div className="section">
        <div className={`container ${containerClassName}`}>{children}</div>
      </div>
    </div>
  );
};

export default CommonPageComponent;
